const getDataCreated = (date, long) => {
    let currentDate = new Date(date);
    if (long) {
        return currentDate.toLocaleString([], {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });
    } else
        return currentDate.toLocaleString([], {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
};
export { getDataCreated };
